var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoutheastAsia12Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 810,
    viewBox: "0 0 520 810",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.699 299.93L517.719 151.54V659.04L260.699 807.43V299.93Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.98 542.55L516.43 395.64L261.98 542.55Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.98 542.55L516.43 395.64",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M310.361 318.04L336.251 303.09C339.091 301.45 341.391 302.78 341.391 306.06V351.35C341.391 354.63 339.091 358.61 336.251 360.25L310.361 375.2C307.521 376.84 305.221 375.51 305.221 372.23V326.94C305.221 323.66 307.521 319.68 310.361 318.04Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M311.879 319.36L334.729 306.17C337.359 304.65 339.489 305.88 339.489 308.92C339.489 311.96 337.359 315.65 334.729 317.16L311.879 330.35C309.249 331.87 307.119 330.64 307.119 327.6C307.119 324.56 309.249 320.87 311.879 319.36Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M310.361 404.11L336.251 389.16C339.091 387.52 341.391 388.85 341.391 392.13V437.42C341.391 440.7 339.091 444.68 336.251 446.32L310.361 461.27C307.521 462.91 305.221 461.58 305.221 458.3V413.01C305.221 409.73 307.521 405.75 310.361 404.11Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M311.879 405.42L334.729 392.23C337.359 390.71 339.489 391.94 339.489 394.98C339.489 398.02 337.359 401.71 334.729 403.22L311.879 416.41C309.249 417.93 307.119 416.7 307.119 413.66C307.119 410.62 309.249 406.93 311.879 405.42Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M374.98 278.77L400.87 263.82C403.71 262.18 406.01 263.51 406.01 266.79V312.08C406.01 315.36 403.71 319.34 400.87 320.98L374.98 335.93C372.14 337.57 369.84 336.24 369.84 332.96V287.67C369.84 284.39 372.14 280.41 374.98 278.77Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M376.5 280.09L399.35 266.9C401.98 265.38 404.11 266.61 404.11 269.65C404.11 272.69 401.98 276.38 399.35 277.89L376.5 291.08C373.87 292.6 371.74 291.37 371.74 288.33C371.74 285.29 373.87 281.6 376.5 280.09Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M374.98 364.84L400.87 349.89C403.71 348.25 406.01 349.58 406.01 352.86V398.15C406.01 401.43 403.71 405.41 400.87 407.05L374.98 422C372.14 423.64 369.84 422.31 369.84 419.03V373.74C369.84 370.46 372.14 366.48 374.98 364.84Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M376.5 366.16L399.35 352.97C401.98 351.45 404.11 352.68 404.11 355.72C404.11 358.76 401.98 362.45 399.35 363.96L376.5 377.15C373.87 378.67 371.74 377.44 371.74 374.4C371.74 371.36 373.87 367.67 376.5 366.16Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M440.941 240.88L466.831 225.93C469.671 224.29 471.971 225.62 471.971 228.9V274.19C471.971 277.47 469.671 281.45 466.831 283.09L440.941 298.04C438.101 299.68 435.801 298.35 435.801 295.07V249.78C435.801 246.5 438.101 242.52 440.941 240.88Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M442.459 242.2L465.309 229.01C467.939 227.49 470.069 228.72 470.069 231.76C470.069 234.8 467.939 238.49 465.309 240L442.459 253.19C439.829 254.71 437.699 253.48 437.699 250.44C437.699 247.4 439.829 243.71 442.459 242.2Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M440.941 326.94L466.831 311.99C469.671 310.35 471.971 311.68 471.971 314.96V360.25C471.971 363.53 469.671 367.51 466.831 369.15L440.941 384.1C438.101 385.74 435.801 384.41 435.801 381.13V335.84C435.801 332.56 438.101 328.58 440.941 326.94Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M442.459 328.26L465.309 315.07C467.939 313.55 470.069 314.78 470.069 317.82C470.069 320.86 467.939 324.55 465.309 326.06L442.459 339.25C439.829 340.77 437.699 339.54 437.699 336.5C437.699 333.46 439.829 329.77 442.459 328.26Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M310.361 558.13L336.251 543.18C339.091 541.54 341.391 542.87 341.391 546.15V591.44C341.391 594.72 339.091 598.7 336.251 600.34L310.361 615.29C307.521 616.93 305.221 615.6 305.221 612.32V567.03C305.221 563.75 307.521 559.77 310.361 558.13Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M311.879 559.45L334.729 546.26C337.359 544.74 339.489 545.97 339.489 549.01C339.489 552.05 337.359 555.74 334.729 557.25L311.879 570.44C309.249 571.96 307.119 570.73 307.119 567.69C307.119 564.65 309.249 560.96 311.879 559.45Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M310.361 644.2L336.251 629.25C339.091 627.61 341.391 628.94 341.391 632.22V677.51C341.391 680.79 339.091 684.77 336.251 686.41L310.361 701.36C307.521 703 305.221 701.67 305.221 698.39V653.1C305.221 649.82 307.521 645.84 310.361 644.2Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M311.879 645.52L334.729 632.33C337.359 630.81 339.489 632.04 339.489 635.08C339.489 638.12 337.359 641.81 334.729 643.32L311.879 656.51C309.249 658.03 307.119 656.8 307.119 653.76C307.119 650.72 309.249 647.03 311.879 645.52Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M374.98 518.87L400.87 503.92C403.71 502.28 406.01 503.61 406.01 506.89V552.18C406.01 555.46 403.71 559.44 400.87 561.08L374.98 576.03C372.14 577.67 369.84 576.34 369.84 573.06V527.77C369.84 524.49 372.14 520.51 374.98 518.87Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M376.5 520.18L399.35 506.99C401.98 505.47 404.11 506.7 404.11 509.74C404.11 512.78 401.98 516.47 399.35 517.98L376.5 531.17C373.87 532.69 371.74 531.46 371.74 528.42C371.74 525.38 373.87 521.69 376.5 520.18Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M374.98 604.93L400.87 589.98C403.71 588.34 406.01 589.67 406.01 592.95V638.24C406.01 641.52 403.71 645.5 400.87 647.14L374.98 662.09C372.14 663.73 369.84 662.4 369.84 659.12V613.83C369.84 610.55 372.14 606.57 374.98 604.93Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M376.5 606.25L399.35 593.06C401.98 591.54 404.11 592.77 404.11 595.81C404.11 598.85 401.98 602.54 399.35 604.05L376.5 617.24C373.87 618.76 371.74 617.53 371.74 614.49C371.74 611.45 373.87 607.76 376.5 606.25Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M440.941 480.97L466.831 466.02C469.671 464.38 471.971 465.71 471.971 468.99V514.28C471.971 517.56 469.671 521.54 466.831 523.18L440.941 538.13C438.101 539.77 435.801 538.44 435.801 535.16V489.87C435.801 486.59 438.101 482.61 440.941 480.97Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M442.459 482.29L465.309 469.1C467.939 467.58 470.069 468.81 470.069 471.85C470.069 474.89 467.939 478.58 465.309 480.09L442.459 493.28C439.829 494.8 437.699 493.57 437.699 490.53C437.699 487.49 439.829 483.8 442.459 482.29Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M440.941 567.04L466.831 552.09C469.671 550.45 471.971 551.78 471.971 555.06V600.35C471.971 603.63 469.671 607.61 466.831 609.25L440.941 624.2C438.101 625.84 435.801 624.51 435.801 621.23V575.94C435.801 572.66 438.101 568.68 440.941 567.04Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M442.459 568.36L465.309 555.17C467.939 553.65 470.069 554.88 470.069 557.92C470.069 560.96 467.939 564.65 465.309 566.16L442.459 579.35C439.829 580.87 437.699 579.64 437.699 576.6C437.699 573.56 439.829 569.87 442.459 568.36Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 151.55L259.52 299.94V807.43L2.5 659.04V151.55Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7793 395.65L258.229 542.56L3.7793 395.65Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7793 395.65L258.229 542.56",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M174.79 304.44L202.89 320.67C205.73 322.31 208.03 326.3 208.03 329.57V376.01C208.03 379.29 205.73 380.62 202.89 378.98L174.79 362.75C171.95 361.11 169.65 357.12 169.65 353.85V307.41C169.65 304.13 171.95 302.8 174.79 304.44Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M171.67 304.88L206.01 324.71V342.65L171.67 322.82V304.88Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M174.79 304.44L202.89 320.67C205.73 322.31 208.03 326.3 208.03 329.57V376.01C208.03 379.29 205.73 380.62 202.89 378.98L174.79 362.75C171.95 361.11 169.65 357.12 169.65 353.85V307.41C169.65 304.13 171.95 302.8 174.79 304.44Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M170.66 322.24L207.02 343.23L170.66 322.24Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M170.66 322.24L207.02 343.23",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M174.79 382.93L202.89 399.16C205.73 400.8 208.03 404.79 208.03 408.06V454.5C208.03 457.78 205.73 459.11 202.89 457.47L174.79 441.24C171.95 439.6 169.65 435.61 169.65 432.34V385.9C169.65 382.62 171.95 381.29 174.79 382.93Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M171.67 383.37L206.01 403.2V421.14L171.67 401.32V383.37Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M174.79 382.93L202.89 399.16C205.73 400.8 208.03 404.79 208.03 408.06V454.5C208.03 457.78 205.73 459.11 202.89 457.47L174.79 441.24C171.95 439.6 169.65 435.61 169.65 432.34V385.9C169.65 382.62 171.95 381.29 174.79 382.93Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M170.66 400.73L207.02 421.72L170.66 400.73Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M170.66 400.73L207.02 421.72",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 241.94L87.1404 258.17C89.9804 259.81 92.2804 263.8 92.2804 267.07V313.51C92.2804 316.79 89.9804 318.12 87.1404 316.48L59.0404 300.25C56.2004 298.61 53.9004 294.62 53.9004 291.35V244.91C53.9004 241.63 56.2004 240.3 59.0404 241.94Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9199 242.38L90.2699 262.21V280.15L55.9199 260.32V242.38Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 241.94L87.1404 258.17C89.9804 259.81 92.2804 263.8 92.2804 267.07V313.51C92.2804 316.79 89.9804 318.12 87.1404 316.48L59.0404 300.25C56.2004 298.61 53.9004 294.62 53.9004 291.35V244.91C53.9004 241.63 56.2004 240.3 59.0404 241.94Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 259.74L91.2702 280.74L54.9102 259.74Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 259.74L91.2702 280.74",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 320.44L87.1404 336.67C89.9804 338.31 92.2804 342.3 92.2804 345.57V392.01C92.2804 395.29 89.9804 396.62 87.1404 394.98L59.0404 378.75C56.2004 377.11 53.9004 373.12 53.9004 369.85V323.41C53.9004 320.13 56.2004 318.8 59.0404 320.44Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9199 320.88L90.2699 340.7V358.65L55.9199 338.82V320.88Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 320.44L87.1404 336.67C89.9804 338.31 92.2804 342.3 92.2804 345.57V392.01C92.2804 395.29 89.9804 396.62 87.1404 394.98L59.0404 378.75C56.2004 377.11 53.9004 373.12 53.9004 369.85V323.41C53.9004 320.13 56.2004 318.8 59.0404 320.44Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 338.23L91.2702 359.23L54.9102 338.23Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 338.23L91.2702 359.23",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M174.79 538.89L202.89 555.12C205.73 556.76 208.03 560.75 208.03 564.02V610.46C208.03 613.74 205.73 615.07 202.89 613.43L174.79 597.2C171.95 595.56 169.65 591.57 169.65 588.3V541.86C169.65 538.58 171.95 537.25 174.79 538.89Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M171.67 539.33L206.01 559.16V577.11L171.67 557.28V539.33Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.79 538.89L202.89 555.12C205.73 556.76 208.03 560.75 208.03 564.02V610.46C208.03 613.74 205.73 615.07 202.89 613.43L174.79 597.2C171.95 595.56 169.65 591.57 169.65 588.3V541.86C169.65 538.58 171.95 537.25 174.79 538.89Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M170.66 556.69L207.02 577.68L170.66 556.69Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M170.66 556.69L207.02 577.68",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M174.79 617.39L202.89 633.62C205.73 635.26 208.03 639.25 208.03 642.52V688.96C208.03 692.24 205.73 693.57 202.89 691.93L174.79 675.7C171.95 674.06 169.65 670.07 169.65 666.8V620.36C169.65 617.08 171.95 615.75 174.79 617.39Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M171.67 617.83L206.01 637.66V655.6L171.67 635.77V617.83Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M174.79 617.39L202.89 633.62C205.73 635.26 208.03 639.25 208.03 642.52V688.96C208.03 692.24 205.73 693.57 202.89 691.93L174.79 675.7C171.95 674.06 169.65 670.07 169.65 666.8V620.36C169.65 617.08 171.95 615.75 174.79 617.39Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M170.66 635.19L207.02 656.18L170.66 635.19Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M170.66 635.19L207.02 656.18",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 476.4L87.1404 492.63C89.9804 494.27 92.2804 498.26 92.2804 501.53V547.97C92.2804 551.25 89.9804 552.58 87.1404 550.94L59.0404 534.71C56.2004 533.07 53.9004 529.08 53.9004 525.81V479.37C53.9004 476.09 56.2004 474.76 59.0404 476.4Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9199 476.84L90.2699 496.66V514.61L55.9199 494.78V476.84Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 476.4L87.1404 492.63C89.9804 494.27 92.2804 498.26 92.2804 501.53V547.97C92.2804 551.25 89.9804 552.58 87.1404 550.94L59.0404 534.71C56.2004 533.07 53.9004 529.08 53.9004 525.81V479.37C53.9004 476.09 56.2004 474.76 59.0404 476.4Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 494.19L91.2702 515.18L54.9102 494.19Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 494.19L91.2702 515.18",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 554.89L87.1404 571.12C89.9804 572.76 92.2804 576.75 92.2804 580.02V626.46C92.2804 629.74 89.9804 631.07 87.1404 629.43L59.0404 613.2C56.2004 611.56 53.9004 607.57 53.9004 604.3V557.86C53.9004 554.58 56.2004 553.25 59.0404 554.89Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9199 555.33L90.2699 575.16V593.1L55.9199 573.27V555.33Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 554.89L87.1404 571.12C89.9804 572.76 92.2804 576.75 92.2804 580.02V626.46C92.2804 629.74 89.9804 631.07 87.1404 629.43L59.0404 613.2C56.2004 611.56 53.9004 607.57 53.9004 604.3V557.86C53.9004 554.58 56.2004 553.25 59.0404 554.89Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 572.69L91.2702 593.69L54.9102 572.69Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9102 572.69L91.2702 593.69",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M260.06 2L517.29 150.51L260.46 298.79L3.23047 150.28L260.06 2Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M263.82 26.27L472.92 147L256.21 272.12L47.0996 151.39L263.82 26.27Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2793 163.75L262.189 52.46L447.679 159.3",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2793 163.75L262.189 52.46L447.679 159.3",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M194.279 129.45L261.099 168.03V206.61L194.279 168.03V129.45Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M262.539 168.03L329.359 129.45V168.03L262.539 206.61V168.03Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M267.119 91.03L326.209 125.15C329.049 126.79 329.049 129.45 326.209 131.09L266.949 165.3C264.109 166.94 259.509 166.94 256.669 165.3L197.579 131.18C194.739 129.54 194.739 126.88 197.579 125.24L256.839 91.03C259.679 89.39 264.279 89.39 267.119 91.03Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoutheastAsia12Dark);
export default __webpack_public_path__ + "static/media/SoutheastAsia12Dark.b4d5bd563961e170892f8a29da4935d5.svg";
export { ForwardRef as ReactComponent };